export default function sum(data): number {
  return data.reduce((sum, d) => d + sum, 0);
}

export function sumBy(data, f): number {
  return data.reduce((sum, d) => f(d) + sum, 0);
}
